import SkeletonCustom from '../SkeletonCustom';
import StripeCertifiedPlug from './StripeCertifiedPlug';

const SkeletonStripe = () => {
  return (
    <>
      <div className="my-8">
        <SkeletonCustom type="paragraph" width="100%" />
      </div>
      <div className="my-8">
        <SkeletonCustom type="paragraph" width="100%" />
      </div>
      <div className="my-8">
        <SkeletonCustom type="paragraph" width="100%" />
      </div>
      <div className="my-8">
        <SkeletonCustom type="paragraph" width="100%" />
      </div>
      <div className="my-8">
        <SkeletonCustom type="paragraph" width="100%" />
      </div>
      <div className="my-8">
        <SkeletonCustom type="paragraph" width="100%" />
      </div>
      <div className="my-8">
        <SkeletonCustom type="paragraph" width="100%" />
      </div>
      <div className="my-8">
        <SkeletonCustom type="paragraph" width="100%" />
      </div>
      <StripeCertifiedPlug />
    </>
  );
};

export default SkeletonStripe;
